import React from 'react'
import { useSelector } from 'react-redux'
import { usePathParam } from '@chilecompra/react-kit'
import { REACT_APP_DJ_ONLY_READ } from '../../config/settings/environment'
import { sendAnalyticsEvent } from '../../config/settings/analytics'
import { Column, ImageInfo, ButtonGrayLink } from './EnrollmentCertificateButton.styles'

/**
 * The Redirect Affidavit Button container.
 */
const RedirectAffidavitButton = () => {
  const dni = usePathParam('rut')
  const { hasAffidavit } = useSelector(state => state.partnershipGridSection)

  const handleClick = () => {
    sendAnalyticsEvent({
      action: `Click Declaración Jurada`,
      category: 'click-boton-DJ',
      label: 'redireccion-declaracion-jurada'
    })
  }

  return (
    <Column margin="0 0 0.5rem 0" padding="0">
      {hasAffidavit && (
        <ButtonGrayLink
          color="secondary"
          onClick={handleClick}
          target="_blank"
          to={`${REACT_APP_DJ_ONLY_READ}/${dni}`}
          variant="outlined"
          width="100%"
        >
          <ImageInfo alt="" />
          Ver Declaración Jurada Registro de Proveedores
        </ButtonGrayLink>
      )}
    </Column>
  )
}

export default RedirectAffidavitButton
